import { render, staticRenderFns } from "./BeefCattleForm.vue?vue&type=template&id=9cf4b6b6"
import script from "./BeefCattleForm.vue?vue&type=script&lang=js"
export * from "./BeefCattleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports